export default __webpack_public_path__ + "static/media/EurEau.fc94b5ed.png";